import EditRecovery from '@/views/constants/recovery-edit';
import ReportsOfSicknessView from '@/views/constants/reports-of-sickness';
import ReportsOfSicknessResource from '@/resources/constants/reports-of-sickness';
import App from '@/views/constants/app';

const Steps = {
  create () {
    return [{
      number: 1,
      title: 'Invoer volledig herstel',
      text: 'Voer de gegevens voor het volledig herstel van het verzuim in. U dient alle velden in te vullen, tenzij deze gemarkeerd zijn met "(optioneel)".',
      completed: false,
      active: true,
      view: EditRecovery.Views.EditRecoveryInputForm,
      navigateAction: EditRecovery.Actions.Navigate.DO
    },
    {
      number: 2,
      title: 'Bevestiging volledig herstel',
      text: 'Controleer alle gegevens en geef bevestiging om het herstel daadwerkelijk in te dienen',
      completed: false,
      active: false,
      view: EditRecovery.Views.EditRecoveryConfirmation,
      navigateAction: EditRecovery.Actions.Navigate.DO
    }];
  }
};

const state = {
  editRecoverySteps: Steps.create()
};

const getters = {
  editRecoverySteps: state => state.editRecoverySteps,
  editRecoveryActiveView: state => state.editRecoverySteps.find(s => s.active).view
};

const actions = {
  [EditRecovery.Actions.Navigate.DO] ({ commit, rootGetters }, data) {
    if (data === EditRecovery.Views.EditRecoveryConfirmation &&
      (!rootGetters.editRecoveryRequiredFields.isValid() || !rootGetters.editRecoveryValidations.isValid())) {
      return;
    }

    commit(EditRecovery.Mutations.ActiveView.SET, data);
  },

  [EditRecovery.Actions.Steps.Completed.UPDATE] ({ commit, rootGetters }) {
    commit(EditRecovery.Mutations.Steps.Completed.SET, {
      isValid: rootGetters.editRecoveryRequiredFields.isValid() && rootGetters.editRecoveryValidations.isValid()
    });
  },
  [ReportsOfSicknessView.Actions.Tabs.OPEN_RECOVERY_EDIT] ({ commit, rootGetters }) {
    commit(EditRecovery.Mutations.Steps.Completed.SET, {
      isValid: rootGetters.editRecoveryRequiredFields.isValid() && rootGetters.editRecoveryValidations.isValid()
    });
  },

  [EditRecovery.Actions.Cancel.DO] ({ commit }) {
    commit(EditRecovery.Mutations.CLEAR);
  },

  [ReportsOfSicknessView.Actions.Tabs.CLOSE] ({ commit }, tab) {
    if (tab.component === 'EditRecovery') {
      commit(EditRecovery.Mutations.CLEAR);
    }
  },

  [ReportsOfSicknessResource.Actions.Period.Create.SUCCESS] ({ commit }) {
    commit(EditRecovery.Mutations.CLEAR);
  }
};

const mutations = {
  [EditRecovery.Mutations.ActiveView.SET] (state, payload) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    state.editRecoverySteps.forEach(s => {
      s.active = (s.view === payload);
    });
  },

  [EditRecovery.Mutations.Steps.Completed.SET] (state, payload) {
    state.editRecoverySteps.forEach(step => {
      if (step.view === EditRecovery.Views.EditRecoveryInputForm) {
        step.completed = payload.isValid;
      }
    });
  },

  [EditRecovery.Mutations.CLEAR] (state) {
    state.editRecoverySteps = Steps.create();
  },

  [App.Mutations.CLEAR] (state) {
    state.editRecoverySteps = Steps.create();
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
